module.exports = __webpack_public_path__ + "img/svg/no-money.2f2557e8980dffbcb945f7611dd17d43.svg";